import Modal from "react-modal";
import { InvoiceTemplate } from "./InvioceTemplate";

export function InvoiceTemplateModal({ open = false, onClose }) {
  

  return (
    <div>
    <Modal isOpen={open} contentLabel="Example Modal">
        <div className="fas fa-times text-xl flex self-end justify-end cursor-pointer p-3">
        </div>
      <InvoiceTemplate />
    </Modal>
    </div>
  );
}
